export type TourDurationParts = {
  day?: number;
  night?: number;
  label: string;
};

/**
 * tour_duration meta: object, JSON string veya düz metin → gün/gece + etiket.
 */
export function parseTourDurationMeta(durationMeta: unknown): TourDurationParts {
  let data: Record<string, unknown> | null = null;

  if (durationMeta != null && typeof durationMeta === 'object' && !Array.isArray(durationMeta)) {
    data = durationMeta as Record<string, unknown>;
  } else if (typeof durationMeta === 'string') {
    const trimmed = durationMeta.trim();
    if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
      try {
        const parsed: unknown = JSON.parse(trimmed);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
          data = parsed as Record<string, unknown>;
        }
      } catch {
        return { label: trimmed };
      }
    } else if (trimmed.length > 0) {
      return { label: trimmed };
    }
  }

  if (!data) {
    return { label: '' };
  }

  const dayRaw = data.day;
  const nightRaw = data.night;
  const day = dayRaw != null && dayRaw !== '' ? Number(dayRaw) : 0;
  const night = nightRaw != null && nightRaw !== '' ? Number(nightRaw) : 0;
  const safeDay = Number.isFinite(day) ? day : 0;
  const safeNight = Number.isFinite(night) ? night : 0;

  const parts: string[] = [];
  if (safeNight > 0) {
    parts.push(`${safeNight} Night${safeNight === 1 ? '' : 's'}`);
  }
  if (safeDay > 0) {
    parts.push(`${safeDay} Day${safeDay === 1 ? '' : 's'}`);
  }

  return {
    day: safeDay > 0 ? safeDay : undefined,
    night: safeNight > 0 ? safeNight : undefined,
    label: parts.length > 0 ? parts.join(' / ') : '',
  };
}
